import { 
  LayoutDashboard, ShoppingBag, Package, Heart, MessageCircle, 
  Ticket, User, MapPin, CreditCard, Bell
} from 'lucide-react';
import { NavLink } from '@/components/NavLink';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar';

const userMenuItems = [
  {
    group: 'Overview',
    items: [
      { title: 'Dashboard', url: '/account', icon: LayoutDashboard, end: true },
    ]
  },
  {
    group: 'Shopping',
    items: [
      { title: 'Orders', url: '/orders', icon: ShoppingBag },
      { title: 'Returns', url: '/returns', icon: Package },
      { title: 'Wishlist', url: '/wishlist', icon: Heart },
    ]
  },
  {
    group: 'Support',
    items: [
      { title: 'Messages', url: '/buyer/chats', icon: MessageCircle },
      { title: 'Tickets', url: '/tickets', icon: Ticket },
    ]
  },
  {
    group: 'Account Settings',
    items: [
      { title: 'Profile', url: '/account/profile', icon: User },
      { title: 'Addresses', url: '/account/addresses', icon: MapPin },
      { title: 'Payment Methods', url: '/account/payment-methods', icon: CreditCard },
      { title: 'Notification Settings', url: '/account/notifications', icon: Bell },
    ]
  }
];

export function UserSidebar() {
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="border-b border-border p-4">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <div className="flex items-center gap-2">
              <User className="h-5 w-5 text-primary" />
              <span className="font-semibold text-foreground">My Account</span>
            </div>
          )}
          <SidebarTrigger className="-mr-1" />
        </div>
      </SidebarHeader>

      <SidebarContent>
        {userMenuItems.map((group) => (
          <SidebarGroup key={group.group}>
            <SidebarGroupLabel>{group.group}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {group.items.map((item) => (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton asChild>
                      <NavLink 
                        to={item.url} 
                        end={item.end}
                        className="flex items-center gap-3 hover:bg-accent/50"
                        activeClassName="bg-accent text-accent-foreground font-medium"
                      >
                        <item.icon className="h-4 w-4 flex-shrink-0" />
                        {!isCollapsed && <span>{item.title}</span>}
                      </NavLink>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
